import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import {
  EmptyCommissionQuery,
  EmptyReportV2CostOfGoodsSoldQuery,
  EmptyReportV2ListingQuery,
  EmptyReportV2PurchaseOrderLineItemQuery,
  EmptyReportV2PurchaseQuery,
  EmptyReportV2SaleCostAdjustmentsQuery,
  EmptyReportV2SaleLineItemQuery,
  EmptyReportV2SaleQuery,
  EmptyReportV2SoldTicketQuery,
  EmptyReportV2TicketGroupQuery,
} from 'src/utils/eventQueryUtils';
import { ReportTypesV2 } from 'src/utils/reportsUtils';

export const REPORT_TYPE_TO_EMPTY_FILTER_QUERY: Record<
  ReportTypesV2,
  ReportConfigV2['request']['filters']
> = {
  [ReportTypesV2.InventoryV2]: EmptyReportV2ListingQuery,
  [ReportTypesV2.SaleLineItem]: EmptyReportV2SaleLineItemQuery,
  [ReportTypesV2.PurchaseOrderLineItem]:
    EmptyReportV2PurchaseOrderLineItemQuery,
  [ReportTypesV2.SoldTicket]: EmptyReportV2SoldTicketQuery,
  [ReportTypesV2.Purchase]: EmptyReportV2PurchaseQuery,
  [ReportTypesV2.SaleV2]: EmptyReportV2SaleQuery,
  [ReportTypesV2.Commission]: EmptyCommissionQuery,
  [ReportTypesV2.CostOfGoodsSold]: EmptyReportV2CostOfGoodsSoldQuery,
  [ReportTypesV2.SaleCostAdjustments]: EmptyReportV2SaleCostAdjustmentsQuery,
  [ReportTypesV2.TicketGroup]: EmptyReportV2TicketGroupQuery,
};
